var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareAndroidFilled = function SvgShareAndroidFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14 5a4 4 0 1 1 1.158 2.815L9.85 10.912a4 4 0 0 1 0 2.175l5.311 3.095a4 4 0 1 1-1.01 1.726l-5.309-3.094a4 4 0 1 1 0-5.63L14.15 6.09A4 4 0 0 1 14 5"
  })));
};
export default SvgShareAndroidFilled;